import { render, staticRenderFns } from "./ProductEditEducation.vue?vue&type=template&id=c5623b26&scoped=true&"
import script from "./ProductEditEducation.vue?vue&type=script&lang=js&"
export * from "./ProductEditEducation.vue?vue&type=script&lang=js&"
import style0 from "./ProductEditEducation.vue?vue&type=style&index=0&id=c5623b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5623b26",
  null
  
)

export default component.exports